import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import Dashboard from './Dashboard';
import PrintQueueView from './PrintQueueView';

const WorkOrdersApp = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute requiredPermission="work-orders:read" requiredRole="admin">
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/print-queue"
        element={
          <ProtectedRoute requiredPermission="work-orders:read" requiredRole="admin">
            <PrintQueueView />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/work-orders" replace />} />
    </Routes>
  );
};

export default WorkOrdersApp;
